var map = {
	"./desktop/large@2x.png": 45522,
	"./desktop/medium@2x.png": 578,
	"./desktop/small@2x.png": 12874,
	"./desktop/ultra_small@2x.png": 76943,
	"./large-desktop.png": 43504,
	"./large-desktop.webp": 79581,
	"./large-desktop@2x.png": 89592,
	"./large-desktop@2x.webp": 54949,
	"./large-mobile.png": 14412,
	"./large-mobile.webp": 41761,
	"./large-mobile@2x.png": 26012,
	"./large-mobile@2x.webp": 3633,
	"./medium-desktop.png": 47342,
	"./medium-desktop.webp": 94423,
	"./medium-desktop@2x.png": 85286,
	"./medium-desktop@2x.webp": 93679,
	"./medium-mobile.png": 32130,
	"./medium-mobile.webp": 89747,
	"./medium-mobile@2x.png": 11090,
	"./medium-mobile@2x.webp": 29443,
	"./mobile/large@2x.png": 83558,
	"./mobile/medium@2x.png": 74174,
	"./mobile/small@2x.png": 63342,
	"./mobile/ultra_small@2x.png": 19603,
	"./original/large-desktop@2x.png": 49114,
	"./original/large-mobile@2x.png": 57294,
	"./original/medium-desktop@2x.png": 55428,
	"./original/medium-mobile@2x.png": 55120,
	"./original/small-desktop@2x.png": 85566,
	"./original/small-mobile@2x.png": 10554,
	"./original/ultra_small-desktop@2x.png": 21851,
	"./original/ultra_small-mobile@2x.png": 63629,
	"./small-desktop.png": 90328,
	"./small-desktop.webp": 91141,
	"./small-desktop@2x.png": 57280,
	"./small-desktop@2x.webp": 40845,
	"./small-mobile.png": 69111,
	"./small-mobile.webp": 26873,
	"./small-mobile@2x.png": 55668,
	"./small-mobile@2x.webp": 56041,
	"./ultra_small-desktop.png": 5235,
	"./ultra_small-desktop.webp": 70520,
	"./ultra_small-desktop@2x.png": 48989,
	"./ultra_small-desktop@2x.webp": 58158,
	"./ultra_small-mobile.png": 44629,
	"./ultra_small-mobile.webp": 65606,
	"./ultra_small-mobile@2x.png": 72479,
	"./ultra_small-mobile@2x.webp": 72060,
	"./what_fits/bicycle.svg": 46198,
	"./what_fits/broom.svg": 57782,
	"./what_fits/cabinet.svg": 42673,
	"./what_fits/chair@2x.png": 78947,
	"./what_fits/clothes.svg": 60601,
	"./what_fits/construction.svg": 83340,
	"./what_fits/documents.svg": 55871,
	"./what_fits/furniture.svg": 20287,
	"./what_fits/goods.svg": 30667,
	"./what_fits/medal.svg": 6732,
	"./what_fits/skates.svg": 74610,
	"./what_fits/sofa.svg": 98050,
	"./what_fits/suitcase.svg": 4300,
	"./what_fits/tent.svg": 15232,
	"./what_fits/tree.svg": 22255,
	"./what_fits/work.svg": 48640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81407;